<div class="wrapper">
  <div
    class="icon"
    #container></div>
  <span
    class="tooltip"
    [ngClass]="{ 'position-top': tooltipPosition === 'top', 'position-bottom': tooltipPosition === 'bottom' }">
    {{ 'activity-sdg.' + key | transloco }}
  </span>
</div>
